import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  petName: string;
  onPetNameChange: (name: string) => void;
  onClose: () => void;
  onProceed: () => void;
}

const PetNameModal: React.FC<Props> = ({ petName, onPetNameChange, onClose, onProceed }) => (
  <Box
    sx={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999,
    }}
    onClick={onClose}
  >
    <Box
      sx={{
        backgroundColor: 'white', borderRadius: '24px', padding: '48px',
        width: '500px', maxWidth: '90%',
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '32px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography
        sx={{
          fontFamily: 'MuseoModerno', fontWeight: 600, fontSize: '24px',
          background: 'linear-gradient(to right, #F39A81, #959BEA)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}
      >
        What's your pet's name?
      </Typography>

      <input
        type="text"
        placeholder="Pet Name"
        value={petName}
        onChange={(e) => onPetNameChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') onProceed(); }}
        style={{
          width: '100%',
          padding: '20px 32px',
          fontSize: '18px',
          fontFamily: 'Maven Pro',
          border: '2px solid #000',
          borderRadius: '100px',
          outline: 'none',
          textAlign: 'center',
          color: '#999',
          background: 'white',
        }}
      />

      <button
        onClick={onProceed}
        style={{
          background: 'linear-gradient(to right, #F39A81, #959BEA)',
          color: 'white',
          fontFamily: 'Maven Pro',
          fontWeight: 600,
          fontSize: '20px',
          padding: '18px 80px',
          borderRadius: '100px',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.05)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
        }}
      >
        Save
      </button>
    </Box>
  </Box>
);

export default PetNameModal;
